import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import {
  createContractCancellationExpenses,
  updateContractCancellationExpenses,
} from 'modules/settings/api';

export const useMutationContractCancellationExpenses = () => {
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();
  const { mutateAsync: mutateCreate, isLoading: createMutationLoader } = useMutation(
    createContractCancellationExpenses,
    {
      onSuccess: () => {
        successToast();
      },
      onError: () => errorToast(),
      onSettled: () =>
        queryClient.refetchQueries(QUERY_KEYS.CONTRACT_PAYMENT_CANCELLATION_EXPENSES),
    },
  );

  const { mutateAsync: mutateUpdate, isLoading: updateMutationLoader } = useMutation(
    updateContractCancellationExpenses,
    {
      onSuccess: () => {
        successToast();
      },
      onError: () => errorToast(),
      onSettled: () =>
        queryClient.refetchQueries(QUERY_KEYS.CONTRACT_PAYMENT_CANCELLATION_EXPENSES),
    },
  );

  return { mutateCreate, mutateUpdate, isLoading: createMutationLoader || updateMutationLoader };
};
